module.exports = __webpack_public_path__ + "static/media/ic_font_size_plus.3df0e6cd.svg";